export class VoipService {
    constructor({
                    ubCustNo = null,
                    csn = null,
                    ubplanid = null,
                    name = null,
                    marketSegment = null,
                    streetNumber = null,
                    streetName = null,
                    streetType = null,
                    suburb = null,
                    state = null,
                    postcode = null,
                    planStartDate = null,
                    contractLength = null,
                    success = null,
                    reason = null,
                } = {}) {
        this.ubCustNo = ubCustNo;
        this.csn = csn;
        this.ubplanid = ubplanid;
        this.name = name;
        this.marketSegment = marketSegment;
        this.streetNumber = streetNumber;
        this.streetName = streetName;
        this.streetType = streetType;
        this.suburb = suburb;
        this.state = state;
        this.postcode = postcode;
        this.planStartDate = planStartDate;
        this.contractLength = contractLength;
        this.success = success;
        this.reason = reason;
    }
}
export function createVoipService(data) {
    return Object.freeze(new VoipService(data));
}

export function createVoipServiceWithHeaderName(data) {
    return new VoipService({
        ubCustNo: data.UBCustNo,
        csn: data.Csn,
        ubplanid: data.UBPLANID,
        name: data.Name,
        marketSegment: data.MarketSegment,
        streetNumber: data.StreetNumber,
        streetName: data.StreetName,
        streetType: data.StreetType,
        suburb: data.Suburb,
        state: data.State,
        postcode: data.Postcode,
        planStartDate: data.PlanStartDate,
        contractLength: data.ContractLength
    });
}